import { useState } from 'react';
import { API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/lan-languages';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export interface GetAllLanguagesSuccessResponse {
    data: paths[url]['get']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to get all available languages.
 * Then filters to keep only the active languages.
 * Then saves it in Data Context.
 */
export const useGetAllLanguages = () => {
    const { handleCommonErrors } = useApiConfig();
    const { setAllLanguages } = useData();
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            // Mock response with only Portuguese language
            const mockData: GetAllLanguagesSuccessResponse = {
                data: [
                    {
                        id: 1,
                        language_code: 'pt',
                        name: 'Português',
                        is_active: true,
                    },
                ],
            };

            // Simulate API delay
            await new Promise((resolve) => setTimeout(resolve, 500));

            setAllLanguages(mockData);

            // Original API call (commented out)
            /*
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetAllLanguagesSuccessResponse = await response.json();

            setAllLanguages(data);
            */
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, loading };
};
